import { ethers } from "ethers";
import Web3 from "./web3";
import UniswapV3ReaderABI from "../abis/UniswapV3Reader.abi.json";

const protocolMap: Record<string, number> = {
    'UniswapV3': 1,
    'PancakeSwapV3': 3,
    'AerodromeV3': 4,
}

interface TickInfo {
    tick: number; // tick
    price: number; // 价格
    liquidityGross: bigint; // 总流动性
}

export interface TickArray {
    tick: number;
    price: number;
    liquidity: bigint;
    ticks: TickInfo[];
}

export default {
    uniswapV3Ticks: async function (chain: string, pool_id: string, protocol: string, tickSpacing: number): Promise<TickArray> {
        const url = Web3.getNodeUrl(chain ?? '');
        const readerAddress = Web3.getReaderAddress(chain ?? '', protocol ?? '');
        const protocolType = protocolMap[protocol];
        const provider = new ethers.JsonRpcProvider(url);
        const contract = new ethers.Contract(readerAddress, UniswapV3ReaderABI, provider);
        const bitmapIndexStart = -8;
        const bitmapIndexEnd = 8;
        console.log({
            pool: pool_id,
            poolType: protocolType,
            bitmapOffsetStart: bitmapIndexStart,
            bitmapOffsetEnd: bitmapIndexEnd,
        })
        const response = await contract.uniswapV3Ticks({
            pool: pool_id,
            poolType: protocolType,
            bitmapOffsetStart: bitmapIndexStart,
            bitmapOffsetEnd: bitmapIndexEnd,
        });
        let tickArray: TickArray = {
            tick: Number(response.tick),
            price: Number(1.0001 ** Number(response.tick)),
            liquidity: response.liquidity,
            ticks: Array.from({ length: response.ticks.length }, () => ({
                tick: 0,
                price: 0,
                liquidityGross: BigInt(0)
            }))
        };

        let valid = 0
        for (let i = 0; i < response.ticks.length; i++) {
            if (response.ticks[i].tick >= response.tick && valid == 0) {
                valid = 1;
            }
            if (valid > 0) {
                tickArray.ticks[i].tick = Number(response.ticks[i].tick);
                if (response.ticks[i].tick == response.tick) {
                    tickArray.ticks[i].liquidityGross = BigInt(response.liquidity);
                    valid = 2;
                } else {
                    if (valid > 1) {
                        tickArray.ticks[i].liquidityGross = tickArray.ticks[i - 1].liquidityGross + BigInt(response.ticks[i].liquidityNet);
                    } else {
                        tickArray.ticks[i].liquidityGross = BigInt(response.liquidity) + BigInt(response.ticks[i].liquidityNet);
                        valid = 2;
                    }
                }
            }
        }

        valid = 0
        for (let i = response.ticks.length - 1; i >= 0; i--) {
            if (response.ticks[i].tick <= response.tick && valid == 0) {
                valid = 1;
            }
            if (valid > 0) {
                tickArray.ticks[i].tick = Number(response.ticks[i].tick);
                if (response.ticks[i].tick == response.tick) {
                    tickArray.ticks[i].liquidityGross = BigInt(response.liquidity);
                    valid = 2;
                } else {
                    if (valid > 1) {
                        tickArray.ticks[i].liquidityGross = tickArray.ticks[i + 1].liquidityGross - BigInt(response.ticks[i].liquidityNet);
                    } else {
                        tickArray.ticks[i].liquidityGross = BigInt(response.liquidity) - BigInt(response.ticks[i].liquidityNet);
                        valid = 2;
                    }
                }
            }
        }

        const tickOffset = Number(response.tick) - Number(response.tick) % 256;
        if (response.ticks.length == 0) {
            tickArray.ticks = tickArray.ticks.concat({
                tick: bitmapIndexStart * 256 * tickSpacing + tickOffset,
                price: 0,
                liquidityGross: response.liquidity,
            }, {
                tick: bitmapIndexEnd * 256 * tickSpacing + tickOffset,
                price: 0,
                liquidityGross: response.liquidity,
            });
        } else {
            tickArray.ticks = [{
                tick: bitmapIndexStart * 256 * tickSpacing + tickOffset,
                price: 0,
                liquidityGross: tickArray.ticks[0].liquidityGross,
            }, ...tickArray.ticks, {
                tick: bitmapIndexEnd * 256 * tickSpacing + tickOffset,
                price: 0,
                liquidityGross: tickArray.ticks[tickArray.ticks.length - 1].liquidityGross,
            }]
        }

        for (let i = 0; i < tickArray.ticks.length; i++) {
            tickArray.ticks[i].price = 1.0001 ** tickArray.ticks[i].tick;
        }

        return tickArray;
    },
    tickToPrice: function (tick: number, decimals0: number, decimals1: number): number {
        return (1.0001 ** tick) * (10 ** (decimals0 - decimals1));
    },
}